import Vue from 'vue'
import {
  ConfigProvider,
  Drawer,
  Input,
  Button,
  Select,
  Card,
  FormModel,
  Row,
  Col,
  Modal,
  Icon,
  List,
  Pagination,
  message,
  Empty,
  DatePicker,
  TreeSelect
} from 'ant-design-vue'

Vue.use(Drawer)
Vue.use(Row)
Vue.use(Col)
Vue.use(Card)
Vue.use(FormModel)
Vue.use(Input)
Vue.use(Button)
Vue.use(List)
Vue.use(Icon)
Vue.use(Pagination)
Vue.use(ConfigProvider)
Vue.use(Modal)
Vue.use(Select)
Vue.use(Empty)
Vue.use(DatePicker)
Vue.use(TreeSelect)
Vue.prototype.$message = message
